
import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';

import warningIcon from './../../../../assets/warning.svg';
import styles from './session-expired.module.scss';

const SessionExpired = () => {
  //Flush all user credentials
  useEffect(()=>{
    localStorage.clear();
  })
  return (
    <Container className={styles['session-expired']}>
      <div className={styles['container']}>
        <div>
          <img src={warningIcon}/>
        </div>
        <div className={styles['title']}>
          Session Expired
        </div>
        <div className={styles['body']}>
          Your session has expired. Contact your selling agent.
        </div>
      </div>
    </Container>
  )
}

export default SessionExpired;




